import React from "react";

export default function AWS_Quicksight() {
  return (
    <div>
      <h1>What is AWS Quicksight</h1>
      <p>
        Route: <code>/aws/quicksight</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
